import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEVICE_KEY = "caliche_device_id";
const UNLOCK_KEY = "caliche_unlocked";

function uuid() {
  if (crypto?.randomUUID) return crypto.randomUUID();
  return "d-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

export function useUnlock() {
  const [unlocked, setUnlocked] = useState(() => localStorage.getItem(UNLOCK_KEY) === "1");
  const [premiumUnlocked, setPremiumUnlocked] = useState(() => localStorage.getItem("caliche_premium") === "1");
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    setChecking(true);
    try {
      const deviceId = getDeviceId();
      const res = await axios.get(`${API}/payments/status/${deviceId}`);
      const isUnlocked = !!res.data?.unlocked;
      const isPremium = !!res.data?.premium_unlocked;
      setUnlocked(isUnlocked);
      setPremiumUnlocked(isPremium);
      if (isUnlocked) localStorage.setItem(UNLOCK_KEY, "1"); else localStorage.removeItem(UNLOCK_KEY);
      if (isPremium) localStorage.setItem("caliche_premium", "1"); else localStorage.removeItem("caliche_premium");
      return { isUnlocked, isPremium };
    } catch {
      return { isUnlocked: unlocked, isPremium: premiumUnlocked };
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const markUnlockedLocally = (plan = "basic") => {
    localStorage.setItem(UNLOCK_KEY, "1");
    setUnlocked(true);
    if (plan === "premium") {
      localStorage.setItem("caliche_premium", "1");
      setPremiumUnlocked(true);
    }
  };

  return { unlocked, premiumUnlocked, checking, refresh, markUnlockedLocally };
}

export async function startCheckout(plan = "basic") {
  const deviceId = getDeviceId();
  const res = await axios.post(`${API}/payments/create-preference`, { device_id: deviceId, plan });
  return res.data;
}

export async function verifyPaymentReturn(orderId, paymentId) {
  const res = await axios.get(`${API}/payments/verify`, {
    params: { order_id: orderId, payment_id: paymentId },
  });
  return res.data;
}
